import api from '@pray/shared/utils/api';

export async function getDonationPayouts(artistId = '', offset = '', limit = '') {
  if (!artistId) throw new Error('Artist ID is required');

  const params = {};

  if (offset) params.offset = offset;
  if (limit) params.limit = limit;

  const url = `/web/studio/artists/${artistId}/payouts`;
  const response = await api.executeGetRequest(url, params);

  return response.data;
}
